import React, { useMemo } from "react";
import styles from "../Styles/BaseStyleForAdminPanel.module.css";

interface OptionItem {
    value: string;
    label: string;
}

interface OpenCheckboxListProps {
    label: string;
    name: string;
    options: OptionItem[];
    selected: string[];
    onChange: (event: any) => void;
    searchValue: string;
    onSearchChange: (value: string) => void;
}

const OpenCheckboxList = ({
                              label,
                              name,
                              options,
                              selected,
                              onChange,
                              searchValue,
                              onSearchChange,
                          }: OpenCheckboxListProps) => {
    const filteredOptions = useMemo(() => {
        const q = searchValue.trim().toLowerCase();
        if (!q) return options;
        return options.filter((o) => o.label.toLowerCase().includes(q));
    }, [options, searchValue]);

    const handleToggle = (value: string) => {
        const isSelected = selected.includes(value);
        const next = isSelected
            ? selected.filter((v) => v !== value)
            : [...selected, value];

        onChange({ target: { name, value: next } });
    };

    return (
        <div className={styles.fullRow}>
            <div className={styles.sectionHeader}>
                <h4 className={styles.sectionTitle}>{label}</h4>
            </div>

            <div className={styles.searchInput} style={{ marginBottom: 10 }}>
                <span className={styles.searchIcon}>🔍</span>
                <input
                    className={styles.searchField}
                    placeholder="Поиск"
                    value={searchValue}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
            </div>

            <div className={styles.checkboxListContainer}>
                {filteredOptions.map((opt) => {
                    const isChecked = selected.includes(opt.value);

                    return (
                        <label
                            key={opt.value}
                            className={`${styles.checkboxListItem} ${
                                isChecked ? styles.checkboxListItemChecked : ""
                            }`}
                        >
                            <input
                                type="checkbox"
                                className={styles.checkboxInput}
                                checked={isChecked}
                                onChange={() => handleToggle(opt.value)}
                            />
                            <span className={styles.checkboxLabel}>{opt.label}</span>
                        </label>
                    );
                })}

                {filteredOptions.length === 0 && (
                    <div className={styles.checkboxListItem} style={{ color: "#9CA3AF" }}>
                        Нет результатов
                    </div>
                )}
            </div>
        </div>
    );
};

export default OpenCheckboxList;